import React, { FC } from 'react'
import TextType, { TextProps } from './TextType'

const EmailType: FC<TextProps> = ({ ...rest }) => <TextType type="email" {...rest} />

export default EmailType
